var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectingStatic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2844",
    transform: "translate(-0.128 682.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2846",
    transform: "translate(0.628 -682.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42872",
    "data-name": "Group 42872",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2854",
    transform: "translate(11.638 9.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2856",
    d: "M-61.4,0a2.863,2.863,0,0,1,2.862,2.861A2.863,2.863,0,0,1-61.4,5.723a2.863,2.863,0,0,1-2.862-2.862A2.863,2.863,0,0,1-61.4,0Z",
    transform: "translate(64.267)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2858",
    transform: "translate(5.915 5.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2860",
    d: "M-184.215,0a8.589,8.589,0,0,1,8.585,8.585,8.589,8.589,0,0,1-8.585,8.585A8.589,8.589,0,0,1-192.8,8.585,8.589,8.589,0,0,1-184.215,0Z",
    transform: "translate(192.8)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2864",
    d: "M-61.4,0a2.863,2.863,0,0,1,2.862,2.862A2.863,2.863,0,0,1-61.4,5.723a2.863,2.863,0,0,1-2.862-2.862A2.863,2.863,0,0,1-61.4,0Z",
    transform: "translate(64.267)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2866",
    transform: "translate(0 23.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2868",
    d: "M-61.4-122.81a2.863,2.863,0,0,0,2.862-2.862,2.863,2.863,0,0,0-2.862-2.862,2.863,2.863,0,0,0-2.862,2.862A2.863,2.863,0,0,0-61.4-122.81Z",
    transform: "translate(64.267 128.533)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2870",
    transform: "translate(23.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2872",
    d: "M-61.4,0a2.863,2.863,0,0,0-2.862,2.862A2.863,2.863,0,0,0-61.4,5.723a2.863,2.863,0,0,0,2.862-2.862A2.863,2.863,0,0,0-61.4,0Z",
    transform: "translate(64.267)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2874",
    transform: "translate(23.277 23.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2876",
    d: "M-61.4-122.81a2.863,2.863,0,0,1-2.862-2.862,2.863,2.863,0,0,1,2.862-2.862,2.863,2.863,0,0,1,2.862,2.862A2.863,2.863,0,0,1-61.4-122.81Z",
    transform: "translate(64.267 128.533)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2878",
    transform: "translate(9.731 15.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2880",
    d: "M0-132.686V-134.1a4.772,4.772,0,0,1,4.769-4.769A4.772,4.772,0,0,1,9.538-134.1v1.414a8.541,8.541,0,0,1-4.769,1.447A8.541,8.541,0,0,1,0-132.686Z",
    transform: "translate(0 138.869)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2882",
    transform: "translate(4.959 4.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2884",
    d: "M0,0,3.354,3.354",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2886",
    transform: "translate(4.959 20.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2888",
    d: "M0-71.966,3.354-75.32",
    transform: "translate(0 75.32)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2890",
    transform: "translate(20.687 4.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2892",
    d: "M-71.978,0l-3.354,3.354",
    transform: "translate(75.332)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2894",
    transform: "translate(20.687 20.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2896",
    d: "M-71.978-71.966l-3.354-3.354",
    transform: "translate(75.332 75.32)",
    fill: "none",
    stroke: "#94a3ac",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingStatic);
export default __webpack_public_path__ + "static/media/connecting-static.5c78c964ddb2b1b79d74c68dc0dad21f.svg";
export { ForwardRef as ReactComponent };